import { render } from "./FAQView.vue?vue&type=template&id=3e397987&scoped=true&ts=true"
import script from "./FAQView.vue?vue&type=script&lang=ts"
export * from "./FAQView.vue?vue&type=script&lang=ts"

import "./FAQView.vue?vue&type=style&index=0&id=3e397987&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e397987"]])

export default __exports__